import { twMerge } from 'tailwind-merge';

import { Icon } from './icon';

interface LoadingProps {
  className?: string;
}

export const Loading = ({ className }: LoadingProps) => (
  <Icon icon="spinner" className={twMerge('animate-spin', className)} />
);
